import Page from "../components/Page";
import VideosSection from "../components/Videos";
import ResourceLinks from "../components/ResourceLinks";

export default function Resources() {
	return (
		<Page title="Resources">
			{/* Each keeps its own heading as a subsection of the page */}
			<ResourceLinks />
			<VideosSection />
		</Page>
	);
}
